import {
  HiOutlineArchiveBox,
  HiOutlineDocumentText,
  HiOutlinePhoto,
  HiOutlineTableCells,
} from "react-icons/hi2";

/** Значок по формату файла: помогает искать глазами, ничего не сообщает сам. */
export function FileTypeIcon({ mimeType }: { mimeType: string | null }) {
  const type = (mimeType ?? "").split(";")[0]?.trim() ?? "";
  const icon = type.startsWith("image/") ? (
    <HiOutlinePhoto />
  ) : /spreadsheet|excel|csv/.test(type) ? (
    <HiOutlineTableCells />
  ) : /zip|rar|7z|gzip|tar/.test(type) ? (
    <HiOutlineArchiveBox />
  ) : (
    <HiOutlineDocumentText />
  );

  return (
    <span className="file-card__icon" aria-hidden="true">
      {icon}
    </span>
  );
}
